import bugsnag from "@bugsnag/js"
import bugsnagReact from "@bugsnag/plugin-react"
import React from "react"
import ReactDOM from "react-dom"
import * as serviceWorker from "serviceWorker"
import { LanguageManager, Auth, Query } from "lib"
import Location from "lib/app/Location"
import { HelmetProvider } from "react-helmet-async"

const bugsnagClient = bugsnag("3fc749f0fb3750f8882b6cb4a5cd584d")
bugsnagClient.use(bugsnagReact, React)
const ErrorBoundary = bugsnagClient.getPlugin("react")
if (window.initialStore) window.isHydrating = true
window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true

ReactDOM.hydrate(
    <ErrorBoundary>
        <HelmetProvider>
            <LanguageManager>
                <Auth>
                    <Location />
                </Auth>
            </LanguageManager>
        </HelmetProvider>
    </ErrorBoundary>,
    document.getElementById("root"),
    () => {
        window.isHydrating = false
        delete window.initialStore
        setTimeout(() => {
            Query.refresh()
        }, 0)
    }
)

serviceWorker.register({
    onUpdate: async registration => {
        // We want to run this code only if we detect a new service worker is
        // waiting to be activated.
        // Details about it: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
        //window.location.reload()
        if (registration && registration.waiting) {
            console.log("update")
            //registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            await registration.unregister()
            // Once the service worker is unregistered, we can reload the page to let
            // the browser download a fresh copy of our app (invalidating the cache)
            window.location.reload()
        }
    },
})
